<div class="sf-wrapper" [class.sf-has-active]="hasActiveFilters">

  <!-- ══ En-tête ══════════════════════════════════════════════════════════ -->
  <div class="sf-header">
    <div class="sf-header__icon">
      <mat-icon>filter_list</mat-icon>
    </div>
    <div class="sf-header__text">
      <span class="sf-header__title">Recherche &amp; Filtres</span>
      <span class="sf-header__sub">Affiner la liste des interventions</span>
    </div>
    <!-- Badge toujours visible : gris si 0 filtre, violet sinon -->
    <div class="sf-header__badge" [class.sf-header__badge--has-value]="hasActiveFilters">
      {{ activeChips.length }}
    </div>
  </div>

  <!-- ══ Corps ════════════════════════════════════════════════════════════ -->
  <div class="sf-body">

    <!-- Recherche texte -->
    <div class="sf-field">
      <label class="sf-field__label" for="sf-search">
        <mat-icon class="sf-field__label-icon">search</mat-icon>
        Recherche par titre
      </label>
      <div class="sf-field__input-wrap sf-field__input-wrap--search">
        <mat-icon class="sf-search-icon">search</mat-icon>
        <input
          id="sf-search"
          type="text"
          class="sf-input"
          [placeholder]="placeholder"
          [ngModel]="_searchTerm"
          (ngModelChange)="onSearchInput($event)"
          autocomplete="off"
        />
        <button *ngIf="_searchTerm" type="button" class="sf-clear-btn"
          aria-label="Effacer la recherche" (click)="clearSearch()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <!-- Période -->
    <div class="sf-period">
      <div class="sf-period__label">
        <mat-icon class="sf-field__label-icon">date_range</mat-icon>
        <span>Période</span>
      </div>
      <div class="sf-period__row">

        <!-- Date début -->
        <div class="sf-field sf-field--date">
          <label class="sf-field__label sf-field__label--small" for="sf-date-start">De</label>
          <div class="sf-field__input-wrap sf-field__input-wrap--date">
            <mat-icon class="sf-date-icon">calendar_today</mat-icon>
            <input #startRef id="sf-date-start" type="date" class="sf-input sf-input--date"
              [(ngModel)]="_startDate" (ngModelChange)="onDateChange()"
              aria-label="Date de début"
              (focus)="openDatePicker(startRef)" (click)="openDatePicker(startRef)" />
            <button *ngIf="_startDate" type="button"
              class="sf-clear-btn sf-clear-btn--inline"
              aria-label="Effacer la date de début" (click)="clearStartDate()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>

        <span class="sf-period__arrow"><mat-icon>arrow_forward</mat-icon></span>

        <!-- Date fin -->
        <div class="sf-field sf-field--date">
          <label class="sf-field__label sf-field__label--small" for="sf-date-end">À</label>
          <div class="sf-field__input-wrap sf-field__input-wrap--date">
            <mat-icon class="sf-date-icon">event</mat-icon>
            <input #endRef id="sf-date-end" type="date" class="sf-input sf-input--date"
              [(ngModel)]="_endDate" (ngModelChange)="onDateChange()"
              aria-label="Date de fin"
              (focus)="openDatePicker(endRef)" (click)="openDatePicker(endRef)" />
            <button *ngIf="_endDate" type="button"
              class="sf-clear-btn sf-clear-btn--inline"
              aria-label="Effacer la date de fin" (click)="clearEndDate()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>

      </div>
    </div>

  </div>
  <!-- ══ FIN Corps ════════════════════════════════════════════════════════ -->

  <!-- ══ Footer — TOUJOURS visible ════════════════════════════════════════ -->
  <div class="sf-footer">

    <!-- Zone chips : affiche les filtres actifs OU le placeholder -->
    <div class="sf-chips">
      <ng-container *ngIf="hasActiveFilters; else emptyState">
        <span *ngFor="let chip of activeChips"
          class="sf-chip"
          [class.sf-chip--search]="chip.key === 'search'"
          [class.sf-chip--date]="chip.key !== 'search'">
          <mat-icon class="sf-chip__icon">{{ chip.icon }}</mat-icon>
          <span class="sf-chip__label">{{ chip.label }}</span>
          <button type="button" class="sf-chip__remove"
            [attr.aria-label]="'Retirer le filtre ' + chip.label"
            (click)="removeChip(chip.key)">
            <mat-icon>close</mat-icon>
          </button>
        </span>
      </ng-container>

      <ng-template #emptyState>
        <span class="sf-chips__empty">
          <mat-icon>filter_alt_off</mat-icon>
          Aucun filtre actif
        </span>
      </ng-template>
    </div>

    <!-- Bouton reset : visible seulement si filtres actifs -->
    <button *ngIf="hasActiveFilters" type="button" class="sf-reset-btn" (click)="resetAll()">
      <mat-icon>restart_alt</mat-icon>
      Réinitialiser
    </button>

  </div>
  <!-- ══ FIN Footer ═══════════════════════════════════════════════════════ -->

</div>